<template>
  <el-input
    clearable
    class="head-search detail"
    :placeholder="media_type == 'feed' || media_type == 'reel' ? '投稿を検索' : 'ストーリーズを検索(ハッシュタグ/メンション/リンクスタンプ/場所タグ)'"
    :value="inputkeyword"
    @focus="focus()"
    @blur="blur()"
    @change="searchKeyword($event)"
    @input="input($event)"
  ></el-input>
</template>

<script>
export default {
  name: "postSearchInput",
  props: {
    inputfocus: {
      type: Boolean,
      default: null,
    },
    inputkeyword: {
      type: String,
      default: null,
    },
    media_type: {
      type: String,
      default: "feed",
    },
  },
  data() {
    return {};
  },
  methods: {
    input(value) {
      this.$emit("update:inputkeyword", value);
    },
    focus() {
      this.$emit("update:inputfocus", true);
    },
    blur() {
      this.$emit("update:inputfocus", false);
    },
    searchKeyword(value) {
      this.$emit("update:inputkeyword", value);
      this.$emit("searchKeyword", "keyword", value);
    },
  },
  watch:{
    media_type(){
      this.$emit("update:inputkeyword", "");
    }
  }
};
</script>

<style></style>
